<template>
    <v-select class="v-select-website" :clearSearchOnSelect="false" v-model="selectedWebsite" :filterable="false" :searchable="false" :clearable="false" :options="websiteOptions" name="webOption"
      @input="updateStore" />
</template>


<script>
import vSelect from 'vue-select'

export default {
  data () {
    return {
      selectedWebsite: {}
    }
  },
  name: 'website-chooser',
  components: {
    vSelect
  },
  props: {
    customFunction: { type: Function, required: false }
  },
  mounted () {
    this.loadCurrentWebsite()
    this.selectedWebsite = this.currentWebsite
  },
  computed: {
    websiteOptions () {
      return this.$store.state.websiteOptions
    },
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  methods: {
    updateStore () {
      this.$store.commit('SET_CURRENT_WEBSITE', this.selectedWebsite)
      this.saveCurrentWebsite()
      this.executeCustomFunction()
    },
    saveCurrentWebsite () {
      this.$store.dispatch('saveCurrentWebsiteToLocalStorage')
    },
    loadCurrentWebsite () {
      this.$store.dispatch('loadCurrentWebsiteFromLocalStorage')
    },
    executeCustomFunction () {
      if (typeof this.customFunction === 'function') {
        this.customFunction(this.currentWebsite.value)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";

.v-select-website {
  min-width: 180px;
}

@media screen and (max-width: 480px) {
  .v-select-website {
    min-width: 70%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
